import { useQuery } from '@tanstack/react-query';

import APIGateway from '@/api';

export const fgaKeys = {
  all: [ 'fga' ] as const,
  capabilities: () => [ ...fgaKeys.all, 'capabilities' ] as const
};

export function useCapabilities( enabled = true ) {
  return useQuery( {
    queryKey: fgaKeys.capabilities(),
    queryFn: async() => {
      const res = await APIGateway.auth.capabilitiesGet();
      return res.capabilities;
    },
    staleTime: 5 * 60 * 1000,
    enabled
  } );
}
